// =====================================================================
// WeddingOS – /guest/announce  (Ankündigung senden, nur delegierte Gäste)
// =====================================================================
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { loadGuestSession } from "../../lib/guestSession";
import { submitAnnouncement, guestCanAnnounce, fetchAnnouncements } from "../../services/supabase";

export default function GuestAnnounce() {
  const navigate = useNavigate();
  const session  = loadGuestSession();

  const [allowed, setAllowed]   = useState(null); // null=lädt
  const [message, setMessage]   = useState("");
  const [sending, setSending]   = useState(false);
  const [done,    setDone]      = useState(false);
  const [error,   setError]     = useState(null);
  const [history, setHistory]   = useState([]);

  // Berechtigung live prüfen (Delegierung kann nach dem Join passieren)
  useEffect(() => {
    if (!session?.guest_id) { setAllowed(false); return; }
    guestCanAnnounce(session.guest_id)
      .then((ok) => { setAllowed(ok); if (!ok) navigate("/guest", { replace: true }); })
      .catch(() => { setAllowed(false); navigate("/guest", { replace: true }); });
  }, [session?.guest_id]);

  useEffect(() => {
    if (allowed !== true || !session?.wedding_id) return;
    fetchAnnouncements(session.wedding_id, 20).then(setHistory).catch(() => {});
  }, [allowed, session?.wedding_id]);

  const send = async () => {
    if (!message.trim() || !session?.guest_id) return;
    setSending(true); setError(null);
    try {
      const a = await submitAnnouncement({ guestId: session.guest_id, message: message.trim() });
      setHistory((p) => [a, ...p]);
      setMessage(""); setDone(true);
      setTimeout(() => setDone(false), 3500);
    } catch (err) {
      setError("Konnte nicht gesendet werden. Bitte nochmal versuchen.");
      console.error(err);
    } finally {
      setSending(false);
    }
  };

  if (!session) {
    return (
      <div className="wos-shell" style={{ textAlign: "center", paddingTop: 80 }}>
        <p className="wos-meta">Sitzung abgelaufen. Bitte Einladungslink neu öffnen.</p>
      </div>
    );
  }
  if (allowed === null) {
    return <div className="wos-shell" style={{ textAlign: "center", paddingTop: 80 }}><p className="wos-meta">Lädt …</p></div>;
  }
  if (allowed === false) return null;

  return (
    <div className="wos-shell">
      <header className="wos-rise" style={{ display: "flex", alignItems: "center", gap: 12, marginBottom: 28 }}>
        <button
          onClick={() => navigate("/guest")}
          aria-label="Zurück"
          style={{ background: "var(--surface)", border: "1px solid var(--line)", borderRadius: "var(--radius-md)",
                   width: 40, height: 40, display: "flex", alignItems: "center", justifyContent: "center",
                   fontSize: 18, color: "var(--ink-muted)", flexShrink: 0, cursor: "pointer" }}
        >←</button>
        <div>
          <p className="wos-eyebrow">Trauzeugen-Modus</p>
          <h1 style={{ fontFamily: "var(--font-display)", fontSize: "1.7rem", marginTop: 2 }}>Ankündigung</h1>
        </div>
      </header>

      {done && (
        <div role="status" style={{ padding: "14px 18px", background: "var(--forest-soft)", border: "1px solid var(--forest)",
          borderRadius: "var(--radius-md)", marginBottom: 20, color: "var(--forest)", fontWeight: 500, fontSize: 15,
          textAlign: "center", animation: "wos-rise 0.3s ease" }}>
          ✓ An alle Gäste gesendet!
        </div>
      )}

      <div className="wos-field">
        <label className="wos-label" htmlFor="announce-msg">Nachricht an alle Gäste</label>
        <textarea id="announce-msg" className="wos-textarea" rows={3} maxLength={200}
          placeholder='z.B. "Anschnitt der Torte in 10 Minuten! 🎂"'
          value={message} onChange={(e) => setMessage(e.target.value)} style={{ resize: "none" }} />
        <p style={{ textAlign: "right", margin: "4px 0 0", fontSize: 12, color: "var(--ink-subtle)" }}>{message.length}/200</p>
      </div>

      {error && <div className="wos-error">{error}</div>}

      <button className="wos-btn wos-btn-primary" onClick={send} disabled={sending || !message.trim()}>
        {sending ? "Senden …" : "An alle senden ✦"}
      </button>

      {history.length > 0 && (
        <div className="wos-rise" style={{ marginTop: 32 }}>
          <p className="wos-eyebrow" style={{ marginBottom: 12 }}>Verlauf</p>
          {history.map((a) => (
            <div key={a.id} style={{ padding: "12px 0", borderBottom: "1px solid var(--line)" }}>
              <p style={{ fontSize: 14, color: "var(--ink)", margin: "0 0 4px" }}>{a.message}</p>
              <p style={{ fontSize: 11, color: "var(--ink-subtle)", margin: 0 }}>
                {new Date(a.created_at).toLocaleString("de-DE")}
              </p>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
